import { LoadingSkeleton } from '@/generic/loader';
import {
  IpponBadge,
  IpponCard,
  IpponHSpace,
  IpponText,
  IpponVSpace,
  IpponVSpaceSlot,
} from '@ippon-ui/react';

const RuleCard = () => (
  <IpponCard border dataSelector="rules-management.rules.rule">
    <IpponVSpace gap={8}>
      <IpponHSpace gap={8} align="middle">
        <IpponText
          variant="body"
          size="small"
          weight="bold"
          color="brand-primary"
          dataSelector="rule.id"
          placeholder
        />
        <IpponText variant="body" size="small" dataSelector="rule.title" placeholder />
        <IpponBadge dataSelector="rule.severity" placeholder />
        <IpponBadge dataSelector="rule.organization" placeholder />
      </IpponHSpace>
      <IpponText
        variant="body"
        size="small"
        color="neutral-tertiary-inversed"
        dataSelector="rule.description"
        placeholder
      />
    </IpponVSpace>
  </IpponCard>
);

export const RuleLoadingComponent = () => (
  <LoadingSkeleton>
    <IpponVSpace gap={8}>
      <IpponVSpaceSlot align="left">
        <IpponText variant="body" weight="bold" tag="h3" placeholder />
      </IpponVSpaceSlot>
      <RuleCard />
      <RuleCard />
      <RuleCard />
      <RuleCard />
      <RuleCard />
    </IpponVSpace>
  </LoadingSkeleton>
);
